import { render, staticRenderFns } from "./class-details.vue?vue&type=template&id=2e1cf6e5&scoped=true&"
import script from "./class-details.ts?vue&type=script&lang=ts&"
export * from "./class-details.ts?vue&type=script&lang=ts&"
import style0 from "./class-details.scss?vue&type=style&index=0&id=2e1cf6e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1cf6e5",
  null
  
)

export default component.exports